<template>
	<div>
		<h1>{{ $t('general-settings') }}</h1>
		<div class="form-group clearfix">
			<label>{{ $t('language') }}</label>
			<select v-model="locale" @change="updateLocale(locale)" class="form-control">
				<option
				v-for="(language, key) in $settings.languages"
				:key="key"
				:value="key"
				>{{ language.endonym }}</option>
			</select>
		</div>

	</div>
</template>

<script>
export default {
	name: 'language',
	components: {
	},
	data() {
		return {
			locale: null
		}
	},
	computed: {
	},
	methods: {
		updateLocale(locale) {
			//locale = this.settings.languages[locale].locale
			localStorage.setItem('locale', locale);
			this.$i18n.locale = locale;
			this.$config.getConfig.call(this);
		}
	},
	mounted() {
		this.locale = this.$i18n.locale;
	}
}
</script>
